export default "__VITE_PUBLIC_ASSET__7f3882f2__"